import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
interface CountdownTimerProps {
  initialHours?: number;
  initialMinutes?: number;
  initialSeconds?: number;
  className?: string;
}
export function CountdownTimer({
  initialHours = 4,
  initialMinutes = 12,
  initialSeconds = 35,
  className = ''
}: CountdownTimerProps) {
  const [timeLeft, setTimeLeft] = useState({
    hours: initialHours,
    minutes: initialMinutes,
    seconds: initialSeconds
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        const totalSeconds = prev.hours * 3600 + prev.minutes * 60 + prev.seconds - 1;
        if (totalSeconds <= 0) {
          clearInterval(timer);
          return {
            hours: 0,
            minutes: 0,
            seconds: 0
          };
        }
        return {
          hours: Math.floor(totalSeconds / 3600),
          minutes: Math.floor(totalSeconds % 3600 / 60),
          seconds: totalSeconds % 60
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatNumber = (num: number) => num.toString().padStart(2, '0');
  const TimeBox = ({
    value,
    label
  }: {
    value: string;
    label: string;
  }) => <div className="flex flex-col items-center" data-id="element-399">
      <div className="bg-[#2D2926] rounded-lg px-3 py-2 min-w-[50px] md:min-w-[60px]" data-id="element-400">
        <AnimatePresence mode="popLayout" data-id="element-401">
          <motion.span key={value} initial={{
          y: -20,
          opacity: 0
        }} animate={{
          y: 0,
          opacity: 1
        }} exit={{
          y: 20,
          opacity: 0
        }} transition={{
          duration: 0.3
        }} className="block text-xl md:text-2xl font-bold text-[#C4A882] font-heading text-center" data-id="element-402">
            {value}
          </motion.span>
        </AnimatePresence>
      </div>
      <span className="text-xs text-[#5C4033] mt-1 uppercase tracking-wider" data-id="element-403">
        {label}
      </span>
    </div>;
  return <div className={`flex items-center gap-2 ${className}`} data-id="element-404">
      <TimeBox value={formatNumber(timeLeft.hours)} label="Hrs" data-id="element-405" />
      <span className="text-2xl font-bold text-[#C4A882] mb-5" data-id="element-406">:</span>
      <TimeBox value={formatNumber(timeLeft.minutes)} label="Min" data-id="element-407" />
      <span className="text-2xl font-bold text-[#C4A882] mb-5" data-id="element-408">:</span>
      <TimeBox value={formatNumber(timeLeft.seconds)} label="Seg" data-id="element-409" />
    </div>;
}